export const GITHUB_PATH = "/zrm20";
export const GITHUB_URL = "https://www.github.com" + GITHUB_PATH;

export const LINKEDIN_PATH = "/in/zachmccoy";
export const LINKEDIN_URL = "https://www.linkedin.com" + LINKEDIN_PATH;

export const PORTFOLIO_DOMAIN = "zachrmccoy.com";
export const PORTFOLIO_URL = "https://www." + PORTFOLIO_DOMAIN;